export const OVERVIEW_BOARD_LIMIT = 10;

const isAllEventRow = (row) =>
  Boolean(row?.allEventMetadata) ||
  Boolean(row?.isAllEvents) ||
  /all\s*event/i.test(row?.eventName || "");

export const boardRowName = (row) => {
  if (!row) return "";
  if (row.isIndividualEvent) {
    return row.bowlerName || row.teamName || "";
  }
  const bowlers = Array.isArray(row.bowlers) ? row.bowlers : [];
  if (bowlers.length === 1) {
    return bowlers[0]?.name || row.teamName || "";
  }
  if (bowlers.length === 2) {
    const first = bowlers[0]?.name || "";
    const second = bowlers[1]?.name || "";
    if (first && second) return `${first} and ${second}`;
  }
  return row.teamName || "";
};

export const boardRowScore = (row) => {
  if (!row) return null;
  const score = row.isIndividualEvent
    ? row.individualHandicapTotal || row.individualScratchTotal
    : row.teamHandicapTotal || row.teamScratchTotal;
  if (score == null || score === "") return null;
  const numeric = Number(score);
  return Number.isFinite(numeric) ? numeric : null;
};

export const boardRowPosition = (row) => {
  const raw = row?.position;
  if (typeof raw === "number" && Number.isFinite(raw)) return raw;
  if (typeof raw === "string" && /^\d+$/.test(raw.trim())) {
    return Number(raw.trim());
  }
  return null;
};

export const boardRowHasScore = (row) => {
  const score = boardRowScore(row);
  return score != null && score > 0 && Boolean(boardRowName(row));
};

const eventRank = (row) => {
  if (isAllEventRow(row)) return 2;
  if (!row?.isIndividualEvent) return 0;
  return 1;
};

export const boardEvents = (results = []) => {
  const seen = new Map();
  (results || []).forEach((row, index) => {
    if (!row?.eventId || !boardRowHasScore(row)) return;
    if (seen.has(row.eventId)) return;
    seen.set(row.eventId, {
      id: row.eventId,
      name: row.eventName || "Event",
      isIndividualEvent: Boolean(row.isIndividualEvent),
      rank: eventRank(row),
      index,
    });
  });
  return Array.from(seen.values());
};

export const preferredBoardEventId = (results = [], events = boardEvents(results)) => {
  if (!events.length) return null;
  return [...events].sort((a, b) => a.rank - b.rank || a.index - b.index)[0].id;
};

export const boardNameColumnLabel = (event) =>
  event?.isIndividualEvent ? "Bowler" : "Team";

export const overviewBoardRows = (
  results = [],
  eventId,
  { includePrizes = false, limit = OVERVIEW_BOARD_LIMIT } = {}
) => {
  if (!eventId) return [];
  return (results || [])
    .filter((row) => row.eventId === eventId && boardRowHasScore(row))
    .map((row) => {
      const prize = includePrizes && Number(row.prize) > 0 ? Number(row.prize) : null;
      return {
        position: boardRowPosition(row),
        name: boardRowName(row),
        score: boardRowScore(row),
        prize,
        key: `${row.eventId}-${row.teamId || row.bowlerId || row.position}-${boardRowName(row)}`,
      };
    })
    .sort((a, b) => {
      if (a.position == null && b.position == null) return b.score - a.score;
      if (a.position == null) return 1;
      if (b.position == null) return -1;
      return a.position - b.position;
    })
    .slice(0, limit);
};
